import { PartyEditResult, PartyUpdate, PartyState } from '../../_generatedTypes.g';
import { partyReplaced } from './partiesSlice';
import { getPartyById } from '../../selectors';
import { api, ReadAs } from '../../api';
import { UnknownAction, Dispatch } from 'redux';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';



export const startEditingParty = (partyId: number, parties: PartyState[], dispatch: Dispatch<UnknownAction>) => {
    const party = getPartyById(parties, partyId);
    dispatch(editingPartyStarted(party));
}

export const saveChanges = async (party: PartyState, token: string, dispatch: Dispatch<UnknownAction>) => {
    dispatch(partyEditStatusChanged({ partyId: party.PartyId, editResult: PartyEditResult.Saving }));
    const body: PartyUpdate = {
        Updates: {
            Description_NL: party.Description_NL,
            Description_EN: party.Description_EN,
            ListOrder: party.ListOrder,
        },
        RowVersion: party.RowVersion
    };
    party.URL && (body.Updates.URL = party.URL);
    return await api(token).Parties.Patch<void>(party.PartyId, body)
        .ok((_, response) => {
            const rowVersion = response.headers.get('ETag') as string;
            const updatedPartyWithRowVersion = { ...party, RowVersion: rowVersion };
            dispatch(partyEdited({ partyId: party.PartyId, partyChanges: { RowVersion: rowVersion } }));
            dispatch(partyEditStatusChanged({ partyId: party.PartyId, editResult: PartyEditResult.Success }));
            dispatch(partyReplaced(updatedPartyWithRowVersion));
        }).anyStatus(errors => {
            dispatch(partyEdited({ partyId: party.PartyId, partyChanges: { ModelErrors: errors } }));
            dispatch(partyEditStatusChanged({ partyId: party.PartyId, editResult: PartyEditResult.Error }));
        }, ReadAs.ValidationErrors)
        .fail(() => dispatch(partyEditStatusChanged({ partyId: party.PartyId, editResult: PartyEditResult.Error })))
}

export type PartyById = { [partyId: number]: PartyState };

const partyEditSlice = createSlice({
    name: 'SLICE_partyEdit',
    initialState: {} as PartyById,
    reducers: {
        editingPartyStarted(state, action: PayloadAction<PartyState>) {
            const id = action.payload.PartyId;
            return {
                ...state,
                [id]: {
                    ...action.payload,
                },
            };
        },
        partyEdited(state, action: PayloadAction<{ partyId: number, partyChanges: Partial<PartyState> }>) {
            const id = action.payload.partyId;
            return {
                ...state,
                [id]: {
                    ...state[id],
                    ...action.payload.partyChanges,
                    EditStatus: undefined,
                }
            };
        },
        partyEditStatusChanged(state, action: PayloadAction<{ partyId: number, editResult: PartyEditResult }>) {
            const id = action.payload.partyId;
            return {
                ...state,
                [id]: {
                    ...state[id],
                    ...action.payload,
                    EditResult: action.payload.editResult,
                }
            };
        },
    },
});

export const {
    editingPartyStarted,
    partyEdited,
    partyEditStatusChanged,
} = partyEditSlice.actions

export default partyEditSlice.reducer
